<template>
  <nav class="workspace-tabs" role="tablist" :aria-label="ariaLabel">
    <button
      v-for="item in items"
      :key="itemValue(item)"
      type="button"
      role="tab"
      :class="{ active: value === itemValue(item) }"
      :aria-selected="value === itemValue(item) ? 'true' : 'false'"
      :tabindex="value === itemValue(item) ? 0 : -1"
      @click="$emit('change', itemValue(item))"
    >
      <i v-if="item.icon" :class="item.icon" aria-hidden="true"></i>
      <span>{{ item.label }}</span>
      <em v-if="item.count !== undefined && item.count !== null" class="workspace-tabs__count">{{ item.count }}</em>
    </button>
  </nav>
</template>

<script>
export default {
  name: "WorkspaceTabs",
  props: {
    value: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    ariaLabel: {
      type: String,
      default: "Navigasi workspace",
    },
  },
  methods: {
    itemValue(item) {
      return item.key || item.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.workspace-tabs {
  display: flex;
  gap: 8px;
  width: max-content;
  max-width: 100%;
  margin: 18px 0;
  padding: 6px;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-width: thin;
  background: #edf3f6;
  border: 0;
  border-radius: 12px;
}

.workspace-tabs button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: max-content;
  min-height: 42px;
  padding: 10px 16px;
  color: #65748a;
  background: transparent;
  border: 0;
  border-radius: 10px;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.25;
  white-space: nowrap;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease, box-shadow 160ms ease,
    transform 160ms ease;
}

.workspace-tabs button:hover:not(.active) {
  color: #174f79;
  background: #f2f7fb;
}

.workspace-tabs button:focus-visible {
  outline: 3px solid rgba(30, 149, 143, 0.24);
  outline-offset: 2px;
}

.workspace-tabs button.active {
  color: #087f78;
  background: #fff;
  box-shadow: 0 3px 10px rgba(35, 60, 75, 0.1);
}

.workspace-tabs button.active:active {
  transform: translateY(1px);
}

.workspace-tabs button i {
  flex: 0 0 auto;
  width: 17px;
  font-size: 15px;
  text-align: center;
}

.workspace-tabs__count {
  min-width: 20px;
  padding: 2px 6px;
  color: #fff;
  background: #11958f;
  border-radius: 999px;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
  text-align: center;
}

.workspace-tabs button.active .workspace-tabs__count {
  color: #fff;
  background: #11958f;
}

@media (max-width: 760px) {
  .workspace-tabs {
    position: sticky;
    top: 0;
    z-index: 5;
    gap: 5px;
    margin: 14px 0;
    padding: 6px;
  }

  .workspace-tabs button {
    min-width: max-content;
    min-height: 40px;
    padding: 9px 13px;
    font-size: 11px;
  }
}

@media print {
  .workspace-tabs {
    display: none !important;
  }
}
</style>
